import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";
import FontAwesome from "react-fontawesome";

import PlayerPickerButtons from "./PlayerPickerButtons";
import PlayerPickerDropdownFilter from "./PlayerPickerDropdownFilter";
import PlayerPickerSelect from "./PlayerPickerSelect";

class GenericPicker extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(value, pickerItems) {
				
		//if (event !== null) {
		//	value = event.value;
		//}

		if (this.props.onChange) {
			let pickerItem = _.find(pickerItems, { value: value });
			this.props.onChange(value, (pickerItem) ? pickerItem: undefined);
		}
	}

	render() {

		const { item, pickerItemsDatasourceResource, type, disabled } = this.props;
		const { pickerItemsDatasource, pickerItems } = item;

		console.log(item.value + " >>> VALUE");

		let options = [];

		let newPickerItems = pickerItems.slice(0);

		// Resolve the picker items if it is tied to data source
		let loading, loadingFailure;
		if (pickerItemsDatasourceResource && !_.isEmpty(pickerItemsDatasourceResource)) {
			console.log("Picker Item Data Source", pickerItemsDatasourceResource);
			const ds = pickerItemsDatasourceResource;
			if (ds.loading) {
				loading = <div style={{ margin: "15px" }}><FontAwesome
					name='spinner'
					spin /> Loading data source...</div>;
			} else if (ds.loadingError) {
				loadingFailure = <div style={{ color: "red" }}>Failed to load data source, picker items not available.<div><b>Reason:</b><br />{ds.loadingError}</div></div>;
			} else if (ds.content) {
				const content = ds.content;
				const labelKeys = pickerItemsDatasource.labelKeys;
				const valueKey = pickerItemsDatasource.valueKeys[0];

				// Super hack
				if (_.indexOf(labelKeys, "employeeId") !== -1 || valueKey === "employeeId") {
					this.requiresSignaturePads = true;
				}

				newPickerItems = content ? content.map(entry => {

					const labelParts = labelKeys.map(labelKey => {
						return entry[labelKey];
					})

					return {
						label: labelParts.join(" "),
						value: entry[valueKey],
						searchKey: _.values(entry).join("-")
					}
				}) : [];
			}
		}

		_.each(newPickerItems, (pickerItem, idx) => {
			if (pickerItem.properties && pickerItem.properties !== "") {
				var properties = pickerItem.properties;

				var propertiesObject = JSON.parse(properties);
				Object.assign(pickerItem, propertiesObject);
			}
			options.push({ value: pickerItem.value, label: pickerItem.label });
		});


		let component = <div>Unknown Picker Component Type :(</div>;
		if (loading) {
			component = loading;
		} else if (loadingFailure) {
			component = loadingFailure;
		} else {
			switch (type) {
				case "PlayerPickerButtons": {
					component = <PlayerPickerButtons options={options} item={item} disabled={disabled} onChange={(value) => this.onChange(value, newPickerItems)}/>
					break;
				}
				case "PlayerPickerDropdownFilter": {
					component = <PlayerPickerDropdownFilter options={options} disabled={disabled} item={item} onChange={(value) => this.onChange(value, newPickerItems)}/>
					break;
				}
				case "PlayerPickerSelect": {
					component = <PlayerPickerSelect options={options} disabled={disabled} item={item} onChange={(value) => this.onChange(value, newPickerItems)}/>
					break;
				}	
				default: {
					component = <div>Unknown Picker Component Type :(</div>
				}	
			}
		}

		return component;
	}
}

export default GenericPicker;